import { useState, useMemo } from "react";

import { useSubscriptionItemsQuery } from "../../api";
import type {
  ISubscriptionsProviderContextValue,
  ISubscriptionsProviderContextState,
  ISubscriptionsProviderContextActions,
} from "./SubscriptionsProvider.types";

export function useSubscriptionsState(): ISubscriptionsProviderContextValue {
  const { data: subscriptionItems = [], isLoading: isSubscriptionItemsLoading } = useSubscriptionItemsQuery();
  const [selectedSubscriptionItemId, setSelectedSubscriptionItemId] = useState<number | undefined>(undefined);

  const selectedSubscriptionItem = useMemo(
    () => subscriptionItems.find((item) => item.id === selectedSubscriptionItemId),
    [subscriptionItems, selectedSubscriptionItemId]
  );

  const state = useMemo<ISubscriptionsProviderContextState>(
    () => ({
      subscriptionItems,
      isSubscriptionItemsLoading,
      selectedSubscriptionItem,
      selectedSubscriptionItemId,
    }),
    [subscriptionItems, isSubscriptionItemsLoading, selectedSubscriptionItemId, selectedSubscriptionItem]
  );
  const actions = useMemo<ISubscriptionsProviderContextActions>(
    () => ({
      setSelectedSubscriptionItemId,
    }),
    [setSelectedSubscriptionItemId]
  );

  const value = useMemo(() => ({ state, actions }), [actions, state]);

  return value;
}
